import axiosInstance from "../app/axios";
import { AdminReferralQrDTO } from "../shared/dtos/adminReferralQrDTO";

export const getAdminReferralQrByAdminId = async () => {
  const result = await axiosInstance.get("adminreferralqr");
  return result.data;
};

export const getAdminReferralQrByCode = async (code: string) => {
  const result = await axiosInstance.get(`adminreferralqr/code/${code}`);
  return result.data;
};

export const createAdminReferralQr = async (
  adminReferralQr: AdminReferralQrDTO,
) => {
  const result = await axiosInstance.post("adminreferralqr", adminReferralQr);

  return result;
};
